<div>
    <tabset>
        @for (itemsInClub of campCare.campCareDaysInClubs; track itemsInClub) {
            <tab customClass="session-tab" [heading]="itemsInClub.clubCode">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col" class="text-center">
                                {{ "CampCareList.Date" | translate }}
                            </th>
                            <th scope="col" class="text-center">
                                {{ "CampCareList.AgeRange" | translate }}
                            </th>
                            <th scope="col" class="text-center">
                                {{ "CampCareList.Capacity" | translate }}
                            </th>
                            <th scope="col" class="text-center">
                                {{ "CampCareList.Slots" | translate }}
                            </th>
                            <th scope="col" class="text-center">
                                {{ "CampCareList.Status" | translate }}
                            </th>
                            <th scope="col" class="text-center">
                                {{ "CampCareList.Action" | translate }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (
                            item of itemsInClub.campCareDays
                                | orderby: "date.value";
                            track item
                        ) {
                            <tr [ngClass]="{ disabled: isArchived(item) }">
                                <td style="width: 10%" class="text-center">
                                    {{ item.date | bcDate }}
                                </td>
                                <td style="width: 20%" class="text-center">
                                    {{ item.ageRangeFromInMonths | age }} -
                                    {{ item.ageRangeToInMonths | age }}
                                </td>
                                <td style="width: 10%" class="text-center">
                                    {{ item.capacity }}
                                </td>
                                <td style="width: 20%" class="text-center">
                                    @for (slot of item.slots; track slot) {
                                        <div>
                                            {{ slot.from | timeDisplay }} -
                                            {{ slot.to | timeDisplay }}
                                        </div>
                                    }
                                </td>
                                <td style="width: 10%" class="text-center">
                                    {{
                                        enumTranslate.campCareDayStatus(
                                            item.status
                                        )
                                    }}
                                </td>
                                <td style="width: 20%" class="text-center">
                                    @if (canEdit(item) | async) {
                                        <button
                                            class="btn btn-action btn-primary"
                                            bcClick
                                            (clicked)="edit(item, itemsInClub)"
                                        >
                                            {{
                                                "CampCareList.Edit" | translate
                                            }}
                                        </button>
                                    }
                                    @if (canArchive(item) | async) {
                                        <button
                                            class="btn btn-action btn-danger"
                                            bcClick
                                            (clicked)="
                                                archive(item, itemsInClub)
                                            "
                                        >
                                            {{
                                                "CampCareList.Archive"
                                                    | translate
                                            }}
                                        </button>
                                    }
                                    @if (canActivate(item) | async) {
                                        <button
                                            class="btn btn-action btn-success"
                                            bcClick
                                            (clicked)="
                                                activate(item, itemsInClub)
                                            "
                                        >
                                            {{
                                                "CampCareList.Activate"
                                                    | translate
                                            }}
                                        </button>
                                    }
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
                @if (itemsInClub && itemsInClub.campCareDays.length == 0) {
                    <div class="text-center">
                        {{ "CampCareList.NoCampDays" | translate }}
                    </div>
                }
            </tab>
        }
    </tabset>
</div>
